

export const STORED_PATHNAME_KEY = 'ReturnPathname';